import React, { useState, useEffect, useMemo } from 'react';
import DefaultTextField from 'components/Utils/DefaultTextField';
import './style.scss';
import DefaultButton from 'components/Utils/NewDefaultButton';
import ProgressMessage from 'components/Utils/ProgressMessage';
import _ from 'lodash';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';
import PatientBadge from 'components/Patient/PatientBadge';
import { useAppSelector } from 'careand-redux/store';
import useFetchPatients from 'hooks/useFetchPatients';
import CalendarUtils from 'services/CalendarUtils';
import Icon from 'components/Utils/NewIcon';
import StripeUtils from 'services/StripeUtils';

const OverdueSubscriptions = () => {
  const [subscriptions, setSubscriptions] = useState([]);

  const dispatch = useAppDispatch();

  useFetchPatients(subscriptions);

  useEffect(() => {
    if (!StripeUtils.isEnabled()) return;
    dispatch(api.Payments.getOverdueSubscriptions()).then((result) => {
      if (result) {
        setSubscriptions(_.reverse(result));
      }
    });
  }, []);

  return (
    <div className="overdue-subscriptions full-width">
      {subscriptions.map((subscription) => (
        <SubscriptionRow subscription={subscription} key={subscription.id} />
      ))}
    </div>
  );
};

const SubscriptionRow = ({ subscription }) => {
  const patient = useAppSelector((state) => state.patients.byId[subscription.patient_id]);

  const invoices = subscription.invoices || [];

  const amountDue =
    (invoices || []).map(({ amount_remaining }) => amount_remaining).reduce((a, b) => a + b, 0) /
    100.0;

  const oldestInvoice = invoices[invoices.length - 1];

  return (
    <div className="subscription-row">
      <PatientBadge patient={patient} goToProfile={true} />
      <div className="double-column">
        <span className="title">Subscription</span>
        <span className="value">{subscription.plan.name}</span>
      </div>
      <div className="double-column">
        <span className="title">Created</span>
        <span className="value">{CalendarUtils.format(subscription.created)}</span>
      </div>
      <div className="double-column">
        <span className="title">Unpaid Since</span>
        <span className="value capitalize">
          {oldestInvoice ? CalendarUtils.format(oldestInvoice.date) : 'N/A'}
        </span>
      </div>
      <div className="double-column">
        <span className="title">Cancel At</span>
        <span className="value">
          {subscription.cancel_at ? CalendarUtils.format(subscription.cancel_at) : 'N/A'}
        </span>
      </div>
      <div className="double-column">
        <span className="title">Interval</span>
        <span className="value capitalize">{subscription.plan.interval}</span>
      </div>
      <div className="double-column">
        <span className="title"># Invoices</span>
        <span className="value capitalize">{subscription.invoices.length}</span>
      </div>
      <div className="double-column">
        <span className="title">Amount Due</span>
        <span className="value capitalize">${amountDue.toFixed(2)}</span>
      </div>
      <div className="double-column">
        <span className="title">Attempts</span>
        <span className="value capitalize">
          {oldestInvoice ? oldestInvoice.attempt_count : 'N/A'}
        </span>
      </div>
      <div className="double-column">
        <a href={`https://dashboard.stripe.com/subscriptions/${subscription.id}`} target="_blank">
          <Icon src={['fab', 'stripe']} height="40px" />
          <Icon src="arrow-up-right-from-square" height="15px" />
        </a>
      </div>
    </div>
  );
};

export default OverdueSubscriptions;
